export default "__VITE_ASSET__e_4q0ro7__"